import { render, staticRenderFns } from "./fair-percentage.vue?vue&type=template&id=2fa6e154&"
import script from "./fair-percentage.vue?vue&type=script&lang=js&"
export * from "./fair-percentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports